import * as types from '../../actions/actionTypes';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';
import { __WEB__ } from '../../constants/styles';

const INITIAL_STATE = {
  status: 'no',
  requestResetMFAStatus: 'no',
  errorMessage: null, //{message:'Incorrect Authenticator Token'},
  successMessage: null,
  intentToResetPassword: false,
  errorCode: null,
  needsMFASetup: false,
  needsMFACode: false,
  qrcode: null,
  secret: null,
  resetPasswordToken: null,
};

function fixupErrorMessage(e) {
  if (e.message && e.message === 'INVALID_MFA_TOKEN') {
    e.message = 'Incorrect Authenticator Token';
  }
  if (__WEB__ && e.message && e.message === 'The account with that email already exists') {
    e.message = 'An account with that email already exists. Please click the Login Tab to sign in.';
  }
  return e;
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    // case types.AUTH_USER_REQUEST:
    case types.SET_RESET_PASSWORD_TOKEN:
      return {
        ...state,
        resetPasswordToken: action.payload,
      };
    case types.FORCE_FULL_SYNC:
      return {
        ...state,
        status: 'requesting',
        errorMessage: null,
      };
    case types.AUTH_GETMFA_SUCCESS:
      return {
        ...state,
        status: 'success',
        errorMessage: null,
        needsMFASetup: true,
        qrcode: action.payload.qrcode,
        secret: action.payload.secret,
      };
    case types.AUTH_MISSING_MFA_CODE:
      return {
        ...state,
        status: 'success',
        errorMessage: null,
        needsMFACode: true,
      };
    case types.AUTH_USER_SUCCESS:
      return {
        ...state,
        status: 'success',
        errorMessage: null,
      };
    case types.AUTH_USER_FAILURE:
    case types.INVITE_AUTH_DETAILS_FAILURE:
      return {
        ...state,
        status: 'failed',
        successMessage: null,
        errorMessage: fixupErrorMessage(action.payload),
      };
    case types.AUTH_FORGOT_PASSWORD_REQUEST:
    case types.AUTH_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        status: 'requesting',
        successMessage: null,
        errorMessage: null,
      };
    case types.AUTH_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        status: 'success',
        successMessage: action.payload.data?.message,
        errorMessage: null,
      };
    case types.AUTH_FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        status: 'failed',
        successMessage: null,
        errorMessage: action.payload,
        errorCode: action.payload?.response?.httpStatusCode,
      };
    case types.AUTH_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        status: 'success',
        successMessage: 'Password successfully reset. You may now log in.',
        errorMessage: null,
        needsMFACode: false,
      };
    case types.AUTH_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        status: 'failed',
        successMessage: null,
        errorMessage: fixupErrorMessage(action.payload),
      };
    case types.UNAUTH_USER:
      return {
        ...state,
        intentToResetPassword: action.payload.intentToResetPassword || false,
      };
    case types.RESET_AUTH_STATE:
      if (action.payload?.statusOnly) {
        return {
          ...state,
          status: 'no',
          successMessage: null,
          errorMessage: null,
        };
      }
      return { ...INITIAL_STATE };
    case types.AUTH_RESET_MFA_REQUEST:
      return {
        ...state,
        status: 'no',
        requestResetMFAStatus: 'requesting',
        successMessage: null,
        errorMessage: null,
      };
    case types.AUTH_RESET_MFA_SUCCESS:
      return {
        ...state,
        requestResetMFAStatus: 'success',
        successMessage: 'Check your email inbox for a reset link',
        errorMessage: null,
      };
    case types.AUTH_RESET_MFA_FAILURE:
      return {
        ...state,
        requestResetMFAStatus: 'failed',
        successMessage: null,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}
